module.exports = __webpack_public_path__ + "d1ea27b49304813a7e9d582ef211a30a.pdf";